import React from 'react';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import './App.css';
import './App.scss';
import AdminMain from './components/Admin/AdminMain';
import Store from './components/Store/Store';

function App() {
  return (
    <div>
      <Provider store={Store}>
        <I18nextProvider i18n={i18n}>
          <AdminMain />
        </I18nextProvider>
      </Provider>
    </div>
  );
}

export default App;